import { z } from 'zod'
import { useZodForm, validateEmissionDate } from '@minetrace/ui/forms'

export const taxReportSchema = z.object({
  code: z.string().optional(),
  issueDate: z.string().min(1, 'Fecha de emisión es requerida'),
}).superRefine((data, ctx) => {
  validateEmissionDate(data.issueDate, 'issueDate', ctx)
})

export type TaxReportFormValues = z.infer<typeof taxReportSchema>

const defaultValues: TaxReportFormValues = {
  code: '',
  issueDate: '',
}

export const useStep8TaxReportForm = (props?: { defaultValues?: TaxReportFormValues; disabled?: boolean }) => {
  return useZodForm<TaxReportFormValues>({
    validationSchema: taxReportSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
